import z from 'zod';

export const profileValidationStateSchema = z.object({
  securityCode: z
    .object({
      TargetId: z.string(),
      Type: z.enum(['Sms', 'Email']),
      Code: z.string(),
    })
    .optional(),
});
export type ProfileValidationState = z.infer<typeof profileValidationStateSchema>;

export const profileCodeInputStateSchema = z.object({
  contactType: z.enum(['Sms', 'Email']),
  targetId: z.string().min(1),
});
export type ProfileCodeInputState = z.infer<typeof profileCodeInputStateSchema>;
